import { AnnotatedJsonSchema } from '@web-config-app/core';

/**
 * Check if a schema has any localized properties anywhere in its structure
 */
export const hasLocalizedProperties = (
  schema: AnnotatedJsonSchema,
): boolean => {
  // Direct check if the schema itself is localized
  if (schema['x-entity-localized'] === true) {
    return true;
  }

  // Check if it's an object with properties
  if (schema.properties) {
    // Check each property for localization
    return Object.values(schema.properties).some((property) =>
      hasLocalizedProperties(property as AnnotatedJsonSchema),
    );
  }

  // Check if it's an array with items
  if (schema.items) {
    // If items is an array (tuple validation)
    if (Array.isArray(schema.items)) {
      return schema.items.some((item) =>
        hasLocalizedProperties(item as AnnotatedJsonSchema),
      );
    }
    // If items is a single schema
    return hasLocalizedProperties(schema.items as AnnotatedJsonSchema);
  }

  // Handle oneOf/anyOf/allOf schemas
  if (schema.oneOf || schema.anyOf || schema.allOf) {
    const schemas = schema.oneOf || schema.anyOf || schema.allOf || [];
    return schemas.some((subSchema) =>
      hasLocalizedProperties(subSchema as AnnotatedJsonSchema),
    );
  }

  return false;
};
